import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as z from "zod";
import Container from "@src/components/shared/Container";
import TitleAndDesc from "@src/components/shared/TitleAndDesc";
import { Button } from "@src/components/ui/button";
import {
  Form,
  FormField,
  FormItem,
} from "@src/components/ui/form";
import { Input } from "@src/components/ui/input";
import { DIGIT_SPACE_DASH_LATIN_GEORGIAN_ONLY_REGEX } from "@src/helpers/regex";
import useZustandStore from "@src/helpers/zustand";

const FormSchema = z.object({
  employer: z.string().refine((v) => v),
});

function SelfEmployed() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { data: zData, setData } = useZustandStore((state) => state);


  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      employer: zData.employment.employer,
    },
  });

  function onSubmit(data: z.infer<typeof FormSchema>) {
    setData({
      ...zData,
      employment: {
        ...zData.employment,
        employer: data.employer,
      },
    });
    navigate(`/${i18n.language}/source-of-income`);
  }

  return (
    <Container className="max-md:min-h-[90vh] max-md:bg-white">
      <Form {...form}>
        <div className="py-4">
          <TitleAndDesc
            desc={t("employment.screens.desc")}
            title={t("employment.screens.title")}
          />
        </div>
        <form
          className="flex flex-col gap-3 max-md:mb-40"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <FormField
            control={form.control}
            name="employer"
            render={({ field }) => (
              <FormItem>
                <Input
                  {...field}
                  label={t("employment.selfEmployed.select.employment")}
                  onChange={(e) => {
                    const { target } = e;
                    if (
                      DIGIT_SPACE_DASH_LATIN_GEORGIAN_ONLY_REGEX.test(
                        target.value
                      ) ||
                      !target.value
                    ) {
                      field.onChange(e);
                    }
                  }}
                />
              </FormItem>
            )}
          />
          <div className="z-10 max-md:fixed max-md:bottom-0 max-md:left-0 max-md:right-0">
            <div className="rounded-6 w-full self-end bg-white py-8 max-md:px-4 ">
              <Button
                className="w-full"
                disabled={!form.formState.isValid}
                type="submit"
              >
                {t("continue")}
              </Button>
            </div>
          </div>
        </form>
      </Form>
    </Container>
  );
}

export default SelfEmployed;
